import axios from "axios";
import qs from "qs";
export default {
    data() {
        return {

        }
    },
    methods: {
        downLoad(d, i) {
            // return false
            let f = {}
            let url = ""
            if (i == 1) { f.resourceId = d.resourceId; url = '/server/resource/common/downLoad' }
            if (i == 2) { f.thematicResourceId = d.thematicResourceId; url = '/server/resource/common/download/thematic' }
            if (i == 3) { f.thematicResourceId = d.resourceId; url = '/server/resource/common/download/thematic' }
            if (i == 4) {
                let a = d.fileUrl.split("/")[1];
                let name = d.resourceName + '.' + d.fileUrl.match(/([^\\/]+)\.([^\\/]+)/i)[2]
                let formHtml =
                    "<form id='downLoadForm' style='display:block' method='post' action='" +
                    window.sessionStorage.getItem("uploadUrl") +
                    "/" +
                    a +
                    "/DownloadFile'>" +
                    "<input type='hidden' name='Path' value='" +
                    d.fileUrl +
                    "'>" + "<input type='hidden' name='name' value='" +
                    encodeURI(name) +
                    "'>" +
                    "</form>";
                let divDom = document.createElement("div");
                divDom.innerHTML = formHtml;
                document.body.appendChild(divDom);
                document.getElementById("downLoadForm").submit();
                document.body.removeChild(divDom)
                return false
            }
            axios
                .post(url, qs.stringify(f), {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
                    },
                })
                .then((res) => {
                    // let a = d.fileUrl.split('/')
                    // let name = a[a.length - 1]
                    // let downloadElement = document.createElement('a')
                    // downloadElement.href = window.sessionStorage.getItem("uploadUrl") + "/" + d.fileUrl.split("/")[1] + "/DownloadFile?Path=" + d.fileUrl + '&name=' + d.resourceName + '.' + name.match(/([^\\/]+)\.([^\\/]+)/i)[2]
                    // document.body.appendChild(downloadElement)
                    // downloadElement.click()
                    // document.body.removeChild(downloadElement)
                    // window.URL.revokeObjectURL(href)

                    // let name = d.resourceName + '.' + d.fileUrl.match(/([^\\/]+)\.([^\\/]+)/i)[2]
                    // axios
                    //     .post(
                    //         window.sessionStorage.getItem("uploadUrl") +
                    //         "/" +
                    //         d.fileUrl.split("/")[1] +
                    //         "/DownloadFile",
                    //         { Path: d.fileUrl, name: name },
                    //         {
                    //             responseType: 'blob',
                    //             headers: {
                    //                 clientId: window.sessionStorage.getItem("clientId"),
                    //                 token: window.sessionStorage.getItem("token"),
                    //             },
                    //         }
                    //     )
                    //     .then((res) => {
                    //         let blob = new Blob([res.data], { type: res.headers['content-type'].split(",")[0] })
                    //         let downloadElement = document.createElement('a')
                    //         let href = URL.createObjectURL(blob)
                    //         downloadElement.href = href
                    //         downloadElement.download = name
                    //         document.body.appendChild(downloadElement)
                    //         downloadElement.click()
                    //         document.body.removeChild(downloadElement)
                    //         window.URL.revokeObjectURL(href)
                    //     });

                    let a = d.fileUrl.split("/")[1];
                    let name = d.resourceName + '.' + d.fileUrl.match(/([^\\/]+)\.([^\\/]+)/i)[2]
                    let formHtml =
                        "<form id='downLoadForm' style='display:block' method='post' action='" +
                        window.sessionStorage.getItem("uploadUrl") +
                        "/" +
                        a +
                        "/DownloadFile'>" +
                        "<input type='hidden' name='Path' value='" +
                        d.fileUrl +
                        "'>" + "<input type='hidden' name='name' value='" +
                        encodeURI(name) +
                        "'>" +
                        "</form>";
                    let divDom = document.createElement("div");
                    divDom.innerHTML = formHtml;
                    document.body.appendChild(divDom);
                    document.getElementById("downLoadForm").submit();
                    document.body.removeChild(divDom)

                    //
                    // let x = new XMLHttpRequest();
                    // x.open(
                    //   "POST",
                    //   window.sessionStorage.getItem("uploadUrl") +
                    //     "/" +
                    //     a +
                    //     "/DownloadFile",
                    //   true
                    // );
                    // x.responseType = "blob";
                    // x.setRequestHeader("Content-type", "application/json");
                    // x.setRequestHeader(
                    //   "clientId",
                    //   window.sessionStorage.getItem("clientId")
                    // );
                    // x.setRequestHeader("token", window.sessionStorage.getItem("token"));
                    // let send_data = { Path: d.fileUrl };
                    // let fileName = d.fileUrl.split("/");
                    // fileName = fileName[fileName.length - 1];
                    // x.send(JSON.stringify(send_data));
                    // x.onreadystatechange = function (e) {
                    //   let content = x.response;
                    //   let elink = document.createElement("a");
                    //   elink.download = fileName || "demo.xlsx";
                    //   elink.style.display = "none";
                    //   let blob = new Blob([content]);
                    //   elink.href = URL.createObjectURL(blob);
                    //   document.body.appendChild(elink);
                    //   elink.click();
                    //   document.body.removeChild(elink);
                    //   console.log(x);
                    // };
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/downLoad.js